import { useTranslation } from "react-i18next";

import { AppLayout } from "@/components/AppLayout";
import { PermissionGate } from "@/components/PermissionGate";
import { BillingPanel } from "@/modules/billing";


export default function AdminBillingPage() {
  const { t } = useTranslation();
  return (
    <AppLayout
      title={t("admin.billing.pageTitle")}
      description={t("admin.billing.pageDescription")}
    >
      <PermissionGate
        perm="billing.read"
        fallback={
          <p className="card text-sm text-nb-text-2">{t("admin.noPermission")}</p>
        }
      >
        <BillingPanel />
      </PermissionGate>
    </AppLayout>
  );
}
